import {MESSAGE_TYPE} from './IntegrationConsts';

export function setFullScreen(integrationConnector, fullScreen) {
  integrationConnector.sendMessage({type: MESSAGE_TYPE.SET_FULL_SCREEN, fullScreen});
}

export function previewTemplate(integrationConnector, template) {
  integrationConnector.sendMessage({type: MESSAGE_TYPE.PREVIEW_TEMPLATE, template});
}

export function onTemplateSave(integrationConnector, data) {
  integrationConnector.sendMessage({type: MESSAGE_TYPE.TEMPLATE_SAVE, data});
}

export function onHomeClicked(integrationConnector) {
  integrationConnector.sendMessage({type: MESSAGE_TYPE.HOME_CLICKED});
}
